import { ValueOf } from '@/types/util';

export const EAccountRole = {
  SYSTEM_MANAGER: 'システム管理者',
  SYSTEM_STAFF: 'システム担当者',
  TENANT_MANAGER: 'テナント管理者',
  TENANT_STAFF: 'テナント担当者',
  ACQUIRER_MANAGER: 'アクワイアラ管理者',
  ACQUIRER_STAFF: 'アクワイアラ担当者',
  VALUE_ISSUER_MANAGER: 'バリューイシュア管理者',
  VALUE_ISSUER_STAFF: 'バリューイシュア担当者',
  WALLET_SERVICE_MANAGER: 'ウォレットサービス管理者',
  WALLET_SERVICE_STAFF: 'ウォレットサービス担当者',
  COMPANY_MANAGER: '企業管理者',
  COMPANY_STAFF: '企業担当者',
  SHOP_MANAGER: '店舗管理者',
  SHOP_STAFF: '店舗担当者',
} as const;

export type AccountRoleKey = keyof typeof EAccountRole;
export type AccountRoleValue = ValueOf<typeof EAccountRole>;

export const accountRoleKeys = Object.keys(EAccountRole) as AccountRoleKey[];
export const accountRoleValues = Object.values(EAccountRole) as AccountRoleValue[];

/** v-select用items */
export const accountRoleItems = accountRoleKeys
  .map((key) => ({
    title: EAccountRole[key],
    value: key,
  }));
